const $ = require('jquery');
const flatpickr = require('flatpickr');
const flatpickrDe = require('flatpickr/dist/l10n/de.js').default.de;
const confirmDatePlugin = require('flatpickr/dist/plugins/confirmDate/confirmDate');

class SegmentTimeDomain {
  constructor(localization, segment) {

    this.clearInputs();

    this.localization = localization;
    this.segment = segment;
    this.shownTab = 'interval';

    this.panels = {
      normal: "normal",
      extended: "extended"
    }

    this.dayNames = {
      1: localization.translate('editor.segmentTimeDomain.monday'),
      2: localization.translate('editor.segmentTimeDomain.tuesday'),
      3: localization.translate('editor.segmentTimeDomain.wednesday'),
      4: localization.translate('editor.segmentTimeDomain.thursday'),
      5: localization.translate('editor.segmentTimeDomain.friday'),
      6: localization.translate('editor.segmentTimeDomain.saturday'),
      7: localization.translate('editor.segmentTimeDomain.sunday')
    };

    this.elements = {
      startTime: $('#segmentStartTime'),
      endTime: $('#segmentEndTime'),
      wholeDay: $('#whole-day-checkbox'),
      repeatOptions: $('input[name=\'repeat-options\']'),
      repeatSuboptions: $('input[name=\'repeat-suboptions\']'),
      startDate: $('#segmentStartDate'),
      endDate: $('#segmentEndDate'),
      noEndDate: $('#no-end-date'),
      previewMessage: $('#preview-message'),
      repeatSuboptionDaily: $('#repeat-suboption-daily'),
      repeatSuboptionWeekly: $('#repeat-suboption-weekly'),
      repeatSuboptionMonthly: $('#repeat-suboption-monthly'),
      repeatSuboptionYearly: $('#repeat-suboption-yearly'),
      normalDatePickerStart: $("#createSegmentFormBeginDateTime"),
      normalDatePickerEnd: $("#createSegmentFormEndDateTime"),
      segmentTimeFrameActivePanel: $("#segmentTimeFrameActivePanel"),
      segmentTimeFrameTimeDomain: $("#segmentTimeFrameTimeDomain"),
      segmentTimeFrameStartDate: $("#segmentTimeFrameStartDate"),
      segmentTimeFrameEndDate: $("#segmentTimeFrameEndDate"),
      segmentTimeFrameMessage: $("#segmentTimeFrameMessage"),
      advancedTimeFrameWarning: $("#advanced-timeframe-warning")
    };

    this.picker1 = null;
    this.picker2 = null;

    this.elements.advancedTimeFrameWarning.html("").hide();

    this.addListeners();

    this.preparePanes();
    this.prepopulateWeek();
    this.prepopulateMonth();
    this.buildMessage();

    this.initiateSimpleDateInterval();

    if(segment) {
      this.loadSegmentInformation();
    } else {
      this.changeTab("interval");
      this.showDatePickerPreviewMessage("", "");
    }
  }

  loadSegmentInformation() {
    const beginDate = this.segment.getAttributeByName('start') ? this.segment.getAttributeByName('start') : this.segment.getAttributeByName('detourEditor_start');
    const endDate = this.segment.getAttributeByName('end') ? this.segment.getAttributeByName('end') : this.segment.getAttributeByName('detourEditor_end');

    if (beginDate) {
      this.elements.normalDatePickerStart.val(beginDate);
      this.picker1.setDate(beginDate);
      this.elements.startDate.val(beginDate.split("T")[0]);
    }

    if (endDate) {
      this.elements.normalDatePickerEnd.val(endDate);
      this.picker2.setDate(endDate);
      this.elements.endDate.val(endDate.split("T")[0]);
    } else if(this.segment.getAttributeByName("TimeDomain")) {
      this.elements.noEndDate.prop("checked", true).trigger("change");
    }

    const intervalMessage = this.showDatePickerPreviewMessage(beginDate, endDate);
    this.buildMessage();

    if(this.segment.getAttributeByName("TimeDomain")) {
      this.changeTab("advanced");
      this.parseTimeDomain(this.segment.getAttributeByName("TimeDomain"));
    } else if(this.segment.getAttributeByName("detourEditor_TimeDomain")) {
      this.changeTab("advanced");
      this.parseTimeDomain(this.segment.getAttributeByName("detourEditor_TimeDomain"))
    } else {
      this.changeTab("interval");
      $("#timeframe-description").text(intervalMessage);
      $('#timeframe-description-modify-street').text(intervalMessage);
    }
  }

  changeTab(tab) {
    this.shownTab = tab;
    $("#timedomain-tab-" + tab).tab("show");
  }

  parseTimeDomain(timeDomain) {

    if(timeDomain.includes('*')) {
      timeDomain = timeDomain.split('*')[1];
    }

    const timeDomains = SegmentTimeDomain.getTimeDomains(timeDomain);
    const durations = SegmentTimeDomain.getDurations(timeDomain);

    let startingHours = 0;
    let startingMinutes = 0;

    let addedHours = 0;
    let addedMinutes = 0;
    let wholeDay = false;

    timeDomains.forEach(domain => {
      const hours = SegmentTimeDomain.matchGroups("hours", domain);
      const minutes = SegmentTimeDomain.matchGroups("minutes", domain);

      if(hours.length > 0) {
        startingHours = parseInt(hours[0].substring(1));

        if(minutes.length > 0) {
          startingMinutes = parseInt(minutes[0].substring(1));
        }
      } else {
        this.elements.wholeDay.prop("checked", true).trigger("change");
      }

      const timeDomainsWeekly = SegmentTimeDomain.matchGroups("weekly", domain);
      const timeGroupsMonthly = SegmentTimeDomain.matchGroups("monthly", domain);
      const timeGroupsYearly = SegmentTimeDomain.matchGroups("yearly", domain);

      if(timeDomainsWeekly.length > 0) {
        this.elements.repeatSuboptionWeekly.prop("checked", true).trigger("change");

        timeDomainsWeekly.forEach(timeGroup => {
          let day = parseInt(timeGroup[1]);

          if(day === 1) {
            day = 7;
          } else {
            day = day - 1;
          }

          $(`#weekday-${day}`).prop("checked", true).trigger("change");
        });
      } else if(timeGroupsMonthly.length > 0 && timeGroupsYearly.length === 0) {
        this.elements.repeatSuboptionMonthly.prop("checked", true).trigger("change");

        timeGroupsMonthly.forEach(timeGroup => {
          const day = timeGroup.substring(1);
          $(`#day-${day}`).prop("checked", true).trigger("change");
        })
      } else if(timeGroupsMonthly.length > 0 && timeGroupsYearly.length > 0) {

      }
    });

    if(durations.length > 0) {
      const duration = durations[0];

      wholeDay = SegmentTimeDomain.matchGroups("wholeDay", duration);
      const hours = SegmentTimeDomain.matchGroups("hours", duration);
      const minutes = SegmentTimeDomain.matchGroups("minutes", duration);

      if(hours.length > 0) {
        addedHours = parseInt(hours[0].substring(1));
      }

      if(minutes.length > 0) {
        addedMinutes = parseInt(minutes[0].substring(1));
      }
    }

    if(wholeDay || (addedHours === 0 && addedMinutes === 0)) {
      this.elements.wholeDay.prop("checked", true).trigger("change");
    } else {
      const formatNumber = function (number) {
        return number.toLocaleString("de-DE", {minimumIntegerDigits: 2});
      }

      this.elements.startTime.val(`${formatNumber(startingHours)}:${formatNumber(startingMinutes)}`).trigger("change");

      const totalAddedMinutes = (startingHours + addedHours) * 60 + (startingMinutes + addedMinutes);

      const endTimeHours = Math.floor(totalAddedMinutes / 60);
      const endTimeMinutes = totalAddedMinutes % 60;

      this.elements.endTime.val(`${formatNumber(endTimeHours)}:${formatNumber(endTimeMinutes)}`).trigger("change");
    }
  }

  static getTimeDomains(timeDomain) {
    const regex = /\(([^)]+)\)/gm;

    return SegmentTimeDomain.getRegex(regex, timeDomain);
  }

  static getDurations(timeDomain) {
    const regex = /{([^)]+)}/gm;

    return SegmentTimeDomain.getRegex(regex, timeDomain);
  }

  static matchGroups(type, timeDomain) {
    let regex = ""

    switch(type) {
      case "weekly":
        regex = /[t]{1}\d/gm;
        break;
      case "monthly":
        regex = /[d]\d{1,2}/gm;
        break;
      case "yearly":
        regex = /[M]\d{1,2}/gm;
        break;
      case "wholeDay":
        return timeDomain === "d1";
      case "hours":
        regex = /[h]\d{1,2}/gm;
        break;
      case "minutes":
        regex = /[m]\d{1,2}/gm;
        break;
      default:
        return [];
    }

    return SegmentTimeDomain.getRegex(regex, timeDomain);
  }

  static getRegex(regex, string) {
    let m;
    let groups = [];

    while ((m = regex.exec(string)) !== null) {
      // This is necessary to avoid infinite loops with zero-width matches
      if (m.index === regex.lastIndex) {
        regex.lastIndex++;
      }

      if(m.length > 1) {
        groups.push(m[1]);
      } else {
        groups.push(m[0]);
      }
    }

    return groups;
  }

  showDatePickerPreviewMessage(dateStart, dateEnd) {
    if(dateStart) {
      dateStart = new Date(dateStart);
    }

    if(dateEnd) {
      dateEnd = new Date(dateEnd);
    }

    const container = $("#preview-message-simple-date");
    let message = "";
    container.html("");

    if(!dateStart && !dateEnd) {
      message = this.localization.translate("editor.segmentTimeDomain.messages.always-active");
    } else if(dateStart && !dateEnd) {
      message = this.localization.translate("editor.segmentTimeDomain.messages.normal-active-only-startdate", {date: SegmentTimeDomain.formatDateTime(dateStart)});
    } else if(!dateStart && dateEnd) {
      message = this.localization.translate("editor.segmentTimeDomain.messages.normal-active-only-enddate", {date: SegmentTimeDomain.formatDateTime(dateEnd)});
    } else if(dateStart && dateEnd) {
      if(dateStart.getDate() === dateEnd.getDate() && dateStart.getMonth() === dateEnd.getMonth() && dateStart.getFullYear() === dateEnd.getFullYear()) {
        message = this.localization.translate("editor.segmentTimeDomain.messages.normal-active-start-enddate-same-day", {date: SegmentTimeDomain.formatDate(dateStart), hourStart: `${SegmentTimeDomain.formatHours(dateStart)}`, hourEnd: `${SegmentTimeDomain.formatHours(dateEnd)}`});
      } else {
        message = this.localization.translate("editor.segmentTimeDomain.messages.normal-active-start-enddate", {dateStart: SegmentTimeDomain.formatDateTime(dateStart, true), dateEnd: SegmentTimeDomain.formatDateTime(dateEnd, true)});
      }
    }

    container.html(message);

    this.elements.segmentTimeFrameActivePanel.val(this.panels.normal);
    this.elements.segmentTimeFrameMessage.val(message);

    return message;
  }

  initiateSimpleDateInterval() {
    flatpickr.l10ns.default.firstDayOfWeek = 1;

    // noinspection JSUnusedGlobalSymbols
    const pickerOptions = {
      enableTime: true,
      altInput: true,
      altFormat: 'l, F d, Y - H:i \\U\\h\\r',
      defaultHour: 0,
      time_24hr: true,
      weekNumbers: true,
      static: true,
      dateFormat: 'Z',
      onOpen: (selectedDates, dateStr, instance) => {
        instance.calendarContainer.style.width = 'auto'; // eslint-disable-line no-param-reassign
        instance.daysContainer.style.width = 'auto'; // eslint-disable-line no-param-reassign
      },
      onReady: (selectedDates, dateStr, instance) => {
        instance.altInput.placeholder = this.localization.translate('general.none'); // eslint-disable-line no-param-reassign
      },
      onClose: () => {
        if (!this.validateSegmentStartEndDates()) {
          $('#alertEndDateInPast').removeClass('d-none');
        } else {
          $('#alertEndDateInPast').addClass('d-none');
        }

        const beginDate = this.elements.normalDatePickerStart.val();
        const endDate = this.elements.normalDatePickerEnd.val();

        if (beginDate) {
          this.elements.segmentTimeFrameStartDate.val(beginDate);
        } else {
          this.elements.segmentTimeFrameStartDate.val('');
        }

        if (endDate) {
          this.elements.segmentTimeFrameEndDate.val(endDate);
        } else {
          this.elements.segmentTimeFrameEndDate.val('');
        }

        this.showDatePickerPreviewMessage(beginDate, endDate);
      },
      plugins: [new confirmDatePlugin({})], // eslint-disable-line new-cap
    };

    if (this.localization.currentLanguage === 'de') {
      pickerOptions.locale = flatpickrDe;
      pickerOptions.altFormat = 'l, d. F Y, H:i';
    }

    this.picker1 = flatpickr(this.elements.normalDatePickerStart[0], pickerOptions);
    this.picker2 = flatpickr(this.elements.normalDatePickerEnd[0], pickerOptions);

    const beginDate = this.elements.normalDatePickerStart.val();
    const endDate = this.elements.normalDatePickerEnd.val();

    if (beginDate) {
      this.picker1.setDate(beginDate);
    } else {
      this.picker1.clear();
    }

    if (endDate) {
      this.picker2.setDate(endDate);
    } else {
      this.picker2.clear();
    }
  }

  addListeners() {
    $("#timeDomainsForm").off("change").on("change", "input", (event) => {
      this.buildTimeDomain();
      this.buildMessage();
    });

    this.elements.wholeDay.off("change").on('change', (event) => {
      this.elements.startTime.prop('disabled', event.target.checked);
      this.elements.endTime.prop('disabled', event.target.checked);

      if (event.target.checked) {
        this.elements.startTime.val('00:00');
        this.elements.endTime.val('23:59');
      }
    });

    this.elements.repeatOptions.off("change").on('change', (event) => {
      $('.form-pane')
        .hide();
      $('#form-pane-' + event.target.value)
        .show();
    });

    this.elements.repeatSuboptions.off("change").on('change', (event) => {
      this.preparePanes();
    });

    this.elements.noEndDate.off("change").on('change', (event) => {
      const noEndDate = event.target.checked;

      this.elements.endDate.prop('disabled', noEndDate);

      if (noEndDate) {
        this.elements.endDate.val('');
      }
    });

    $('a[data-toggle="tab"]').on('shown.bs.tab', (event) => {
        const currentTab = event.target.id.replace("timedomain-tab-", "");

        if(currentTab) {
          this.shownTab = currentTab;
        }
    });

    $('#deleteTimeEdits').off().on('click', (event) => {
      event.preventDefault();
      delete this.segment.attributes.start;
      delete this.segment.attributes.end;
      delete this.segment.attributes.TimeDomain;

      this.loadSegmentInformation();
      this.clearInputs();
    });
  }

  preparePanes() {
    $('.form-subpane').hide();

    const activeSubpane = $('input[name=\'repeat-suboptions\']:checked').val();

    if(activeSubpane === "daily") {
      this.elements.startTime.attr("disabled", false);
      this.elements.endTime.attr("disabled", false);
      this.elements.wholeDay.prop("checked", false).parent().hide();
    } else {
      this.elements.wholeDay.parent().show();
    }

    $('#form-subpane-' + activeSubpane).show();
  }

  prepopulateWeek() {
    $('#form-subpane-weekly').html("");

    Object.keys(this.dayNames).forEach(dayKey => {
        const container = $('<div class="form-check form-check-inline">');
        const checkbox = $('<input class="form-check-input" type="checkbox">');
        const label = $('<label class="form-check-label">');

        label.text(this.dayNames[dayKey]);
        checkbox.attr('id', 'weekday-' + dayKey);
        label.attr('for', 'weekday-' + dayKey);

        checkbox.val(dayKey);

        container.append(checkbox);
        container.append(label);

        $('#form-subpane-weekly').append(container);
      });
  }

  prepopulateMonth() {
    const nth = (d) => {
      if(this.localization.language === "de") {
        return ".";
      }

      if (d > 3 && d < 21) return 'th';
      switch (d % 10) {
        case 1:
          return 'st';
        case 2:
          return 'nd';
        case 3:
          return 'rd';
        default:
          return 'th';
      }
    };

    $('#form-subpane-monthly').html("");

    for (let i = 1; i < 32; i++) {
      const container = $('<div class="form-check form-check-inline">');
      const checkbox = $('<input class="form-check-input" type="checkbox">');
      const label = $('<label class="form-check-label">');
      const dayName = i + nth(i);
      label.text(dayName);
      checkbox.attr('id', 'day-' + i);
      checkbox.data('name', dayName);

      label.attr('for', 'day-' + i);

      checkbox.val(i);

      container.append(checkbox);
      container.append(label);

      $('#form-subpane-monthly').append(container);
    }
  }

  setMessage(message, error) {
    const content = $('<div>').text(message);

    if (error) {
      content.addClass('invalid-feedback d-block');
      this.elements.segmentTimeFrameMessage.val("");
    } else {
      this.elements.segmentTimeFrameMessage.val(message);
      $("#timeframe-description").text(message);
      $('#timeframe-description-modify-street').text(message);
    }

    this.elements.previewMessage.html(content);
    this.elements.segmentTimeFrameActivePanel.val(this.panels.extended);
  }

  buildMessage() {
    this.elements.previewMessage.html('');

    this.setMessage(this.localization.translate("editor.segmentTimeDomain.messages.always-active"));

    if ((this.elements.startDate.val() === '') || (this.elements.endDate.val() === '' && !this.elements.noEndDate.is(':checked'))) {
      this.setMessage(this.localization.translate("editor.segmentTimeDomain.errors.no-date"), true);

      return;
    }

    this.setWarnings();
    this.showDatePickerPreviewMessage(this.elements.normalDatePickerStart.val(), this.elements.normalDatePickerEnd.val());

    if (this.elements.startTime.val() === '' || this.elements.endTime.val() === '') {
      this.setMessage(this.localization.translate("editor.segmentTimeDomain.errors.no-time"), true);
      return;
    }

    if (this.elements.startTime.val() > this.elements.endTime.val()) {
      this.setMessage(this.localization.translate("editor.segmentTimeDomain.errors.end-before-start"), true);
      return;
    }

    return this.buildMessageOnRepeat();
  }

  setWarnings() {
    let startDate = null;
    let endDate = null;

    if(this.elements.startDate.val() !== "") {
      startDate = new Date(this.elements.startDate.val());
      startDate.setHours(0);
      startDate.setMinutes(0);
      startDate.setSeconds(0);
    }

    if(this.elements.endDate.val() !== "") {
      endDate = new Date(this.elements.endDate.val());
      endDate.setHours(0);
      endDate.setMinutes(0);
      endDate.setSeconds(0);
    }

    if (this.shownTab === "advanced" && startDate && endDate && startDate.getTime() > endDate.getTime()) {
      $('#alertEndDateInPast').removeClass('d-none');
    } else {
      $('#alertEndDateInPast').addClass('d-none');
    }

    if(this.shownTab === "advanced" && startDate && endDate && startDate.getTime() === endDate.getTime()) {
      return this.elements.advancedTimeFrameWarning.html(this.localization.translate("editor.segmentTimeDomain.errors.dates-are-equal")).show();
    }

    this.elements.advancedTimeFrameWarning.html("").hide();
  }

  static formatDate(date) {
    let selectedDate = new Date(date);
    const options = {
      weekday: 'long',
      year: 'numeric',
      month: 'long',
      day: 'numeric'
    };

    return selectedDate.toLocaleString(undefined, options);
  }

  static formatDateTime(date) {
    let selectedDate = new Date(date);
    let options = {
      weekday: 'long',
      year: 'numeric',
      month: 'long',
      day: 'numeric',
      hour: "2-digit",
      minute: "2-digit"
    };

    return selectedDate.toLocaleString(undefined, options);
  }

  static formatHours(date) {
    let selectedDate = new Date(date);

    const options = {
      "hour": "2-digit",
      "minute": "2-digit"
    }

    return selectedDate.toLocaleString(undefined, options);
  }


  buildMessageOnRepeat() {
    if (this.elements.repeatSuboptionDaily.is(':checked')) {
      return this.buildMessageOnRepeatDaily();
    }

    if (this.elements.repeatSuboptionWeekly.is(':checked')) {
      return this.buildMessageOnRepeatWeekly();
    }

    if (this.elements.repeatSuboptionMonthly.is(':checked')) {
      return this.buildMessageOnRepeatMonthly();
    }

    if (this.elements.repeatSuboptionYearly.is(':checked')) {
      return this.buildMessageOnRepeatYearly();
    }
  }

  setMessageOnRepeat(messageNormal, messageWholeDay) {
    let message = this.localization.translate("editor.segmentTimeDomain.messages.segment-active-whole-day", {messageWholeDay});

    if (!this.elements.wholeDay.is(':checked')) {
      message = this.localization.translate("editor.segmentTimeDomain.messages.segment-active", {messageNormal, start: this.elements.startTime.val(), end: this.elements.endTime.val()});
    }

    message += this.localization.translate("editor.segmentTimeDomain.messages.segment-active-starting-on", {date: SegmentTimeDomain.formatDate(this.elements.startDate.val())});

    if (this.elements.noEndDate.is(':checked')) {
      message += this.localization.translate("editor.segmentTimeDomain.messages.until-cancelled");
    } else {
      message += this.localization.translate("editor.segmentTimeDomain.messages.until-date", {date: SegmentTimeDomain.formatDate(this.elements.endDate.val())});
    }

    this.setMessage(message);
  }

  buildMessageOnRepeatDaily() {
    this.setMessageOnRepeat('', this.localization.translate("editor.segmentTimeDomain.messages.every-day"));
  }

  buildMessageOnRepeatWeekly() {
    const checkedDays = $('#form-subpane-weekly input:checked');

    if (checkedDays.length === 0) {
      this.setMessage(this.localization.translate("editor.segmentTimeDomain.errors.select-days"), true);

      return;
    }

    let checkedDaysNames = '';

    checkedDays.each((index, dayElement) => {
      const dayId = $(dayElement)
        .val();

      if (index > 0 && index !== checkedDays.length - 1) {
        checkedDaysNames += ', ';
      } else if (index > 0 && index === checkedDays.length - 1) {
        checkedDaysNames += ` ${this.localization.translate("editor.segmentTimeDomain.and")} `;
      }

      checkedDaysNames += this.dayNames[dayId];
    });

    this.setMessageOnRepeat(`${this.localization.translate("editor.segmentTimeDomain.messages.every")} ${checkedDaysNames}`, `${this.localization.translate("editor.segmentTimeDomain.messages.every")} ${checkedDaysNames}`);
  }

  buildMessageOnRepeatMonthly() {
    const checkedDays = $('#form-subpane-monthly input:checked');

    if (checkedDays.length === 0) {
      this.setMessage(this.localization.translate("editor.segmentTimeDomain.errors.select-month-days"), true);

      return;
    }

    let checkedDaysNames = '';

    checkedDays.each((index, dayElement) => {
      if (index > 0 && index !== checkedDays.length - 1) {
        checkedDaysNames += ', ';
      } else if (index > 0 && index === checkedDays.length - 1) {
        checkedDaysNames += ` ${this.localization.translate("editor.segmentTimeDomain.and")} `;
      }

      checkedDaysNames += $(dayElement).data('name');
    });

    this.setMessageOnRepeat(this.localization.translate("editor.segmentTimeDomain.messages.every-day-of-month", {checkedDaysNames}), this.localization.translate("editor.segmentTimeDomain.messages.every-day-of-month", {checkedDaysNames}));
  }

  buildMessageOnRepeatYearly() {
    this.setMessageOnRepeat(this.localization.translate("editor.segmentTimeDomain.messages.every-year"), this.localization.translate("editor.segmentTimeDomain.messages.every-year"));
  }

  buildTimeDomain() {
    if (this.elements.startDate.val() !== '') {
      const startDateVal = this.elements.startDate.val() + "T00:00";
      this.elements.segmentTimeFrameStartDate.val(startDateVal);
      this.elements.normalDatePickerStart.val(startDateVal);

      if(this.picker1){
        this.picker1.setDate(startDateVal);
      }
    }

    if (!this.elements.noEndDate.is(':checked') && this.elements.endDate.val() !== '') {
      const endDateVal = this.elements.endDate.val() + "T23:59";
      this.elements.segmentTimeFrameEndDate.val(endDateVal);
      this.elements.normalDatePickerEnd.val(endDateVal).trigger("change");
      if(this.picker2){
        this.picker2.setDate(endDateVal);
      }
    } else {
      this.elements.segmentTimeFrameEndDate.val("");
    }

    let timeDifference = '';
    let timeDomainDate = '';
    let timeDomainTime = '';

    if (this.elements.repeatSuboptionWeekly.is(':checked')) {
      let timeDomainDays = '';

      $('#form-subpane-weekly input:checked')
        .each((index, dayElement) => {
          let dayId = $(dayElement)
            .val();

          if (dayId === '7') {
            dayId = 1;
          } else {
            dayId = parseInt(dayId) + 1;
          }

          timeDomainDays += `t${dayId}`;
        });

      if (timeDomainDays !== '') {
        timeDomainDate = `${timeDomainDays}`;
      }
    }

    if (this.elements.repeatSuboptionMonthly.is(':checked')) {
      let timeDomainMonthDays = [];

      $('#form-subpane-monthly input:checked')
        .each((index, dayElement) => {
          timeDomainMonthDays.push(`d${$(dayElement).val()}`);
        });

      if (timeDomainMonthDays.length > 0) {
        timeDomainDate = timeDomainMonthDays;
      }
    }

    if (this.elements.repeatSuboptionYearly.is(':checked')) {
      let timeDomainYearly = '';
      let startDate = this.elements.startDate.val();

      if (startDate !== '') {
        startDate = new Date(startDate);

        timeDomainYearly = `M${startDate.getMonth() + 1}d${startDate.getDate()}`;
      }
    }

    if (!this.elements.wholeDay.is(':checked')) {
      const timeStart = new Date('02/02/2021 ' + this.elements.startTime.val());
      const timeEnd = new Date('02/02/2021 ' + this.elements.endTime.val());

      const timeStartValue = this.elements.startTime.val().split(':');

      if(timeStartValue.length === 2) {
        const timeStartHour = timeStartValue[0];
        const timeStartMinutes = timeStartValue[1];

        const differenceInMinutes = Math.abs(Math.round((timeEnd.getTime() - timeStart.getTime()) / 1000 / 60));

        const hoursDifference = Math.floor(differenceInMinutes / 60);
        const minutesDifference = differenceInMinutes % 60;

        if (hoursDifference !== 0) {
          timeDifference += `h${hoursDifference}`;
        }

        if (minutesDifference !== 0) {
          timeDifference += `m${minutesDifference}`;
        }

        if (timeDifference !== '') {
          timeDifference = `${timeDifference}`;
        }

        timeDomainTime += `h${parseInt(timeStartHour)}`;

        if (timeStartMinutes !== '00') {
          timeDomainTime += `m${parseInt(timeStartMinutes)}`;
        }
      }
    } else {
      timeDifference = 'd1';
    }

    let result = '';

    if (timeDifference !== '' || timeDomainDate.length > 0) {
      const buildTimeDomain = function (date, time, difference) {
        let timeDomain = `(${date}${time})`;

        if(timeDifference !== "") {
          timeDomain += `{${difference}}`;
        }

        return `[${timeDomain}]`;
      }

      if (timeDomainDate.length > 0 && Array.isArray(timeDomainDate)) {
        result += `[${timeDomainDate.map(date => {
          return buildTimeDomain(date, timeDomainTime, timeDifference);
        }).join("+")}]`;
      } else if( timeDomainDate.length > 0 && !Array.isArray(timeDomainDate)) {
        result += buildTimeDomain(timeDomainDate, timeDomainTime, timeDifference);
      } else if( timeDomainDate.length === 0 && timeDomainTime.length !== 0 ) {
        result += buildTimeDomain("", timeDomainTime, timeDifference);
      }
    }

    this.elements.segmentTimeFrameTimeDomain.val(result);
  }

  validateSegmentStartEndDates() {
    const startDateRaw = this.elements.normalDatePickerStart.val();
    const endDateRaw = this.elements.normalDatePickerEnd.val();

    const startDate = startDateRaw ? new Date(startDateRaw) : null;
    const endDate = endDateRaw ? new Date(endDateRaw) : null;

    return !(startDate && endDate && startDate >= endDate);
  }

  clearInputs() {
    $(".segment-time-frame").find("form").trigger("reset");
    $("#segmentTimeFrameActivePanel, #segmentTimeFrameTimeDomain, #segmentTimeFrameStartDate, #segmentTimeFrameEndDate, #segmentTimeFrameMessage").val("");
    $("#segmentStartDate, #segmentEndDate").attr("disabled", false);

    if(this.picker1) {
      this.picker1.clear();
    }

    if(this.picker2) {
      this.picker2.clear();
    }

    if(this.elements && this.elements.normalDatePickerStart) {
      this.elements.normalDatePickerStart.val('');
    }

    if(this.elements && this.elements.normalDatePickerEnd) {
      this.elements.normalDatePickerEnd.val('');
    }
  }

}

module.exports = SegmentTimeDomain;
